import React from 'react';
import PropTypes from 'prop-types';

import { BarHeader } from 'dibs-elements/exports/BarHeader';

import styles from './PanelText.scss';

export default function PanelText(props) {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <BarHeader title={props.headerCopy} />
                <div className={styles.exposition}>{props.exposition}</div>
                {props.children}
            </div>
        </div>
    );
}

PanelText.propTypes = {
    children: PropTypes.node,
    exposition: PropTypes.node.isRequired,
    headerCopy: PropTypes.node.isRequired,
};
